import { BASKET_API, BasketApi } from 'components/ordering/multiple-baskets/basket-api/basket-api.js'
import { DeliveryPolicy, TrivialDeliveryPolicy } from 'components/ordering/acl/internal-types.js'
import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'
import { sortDeliveryPolicies } from 'components/ordering/multiple-baskets/basket-store/delivery-policy-sorter.js'


const [getDeliveryPolicies, setDeliveryPolicies] = createSignal<DeliveryPolicy[]>(
  []
)
const [getDefault, setDefault] = createSignal<DeliveryPolicy>(
  new TrivialDeliveryPolicy()
)

export const DELIVERY_POLICY_MUTATOR = Symbol('DELIVERY_POLICY_MUTATOR')
export type DeliveryPolicyMutator = {
  initialize: (partyId: number, shopId: number) => void
}


@registerDependency(REAL, DELIVERY_POLICY_MUTATOR)
@registerDependency(FAKE, DELIVERY_POLICY_MUTATOR)
export class ConcreteDeliveryPolicyMutator implements DeliveryPolicyMutator {
  @inject(BASKET_API)
  private basketApi!: BasketApi

  private partyId?: number
  private shopId?: number

  private readonly initialization: Promise<void>
  private resolveInitialization!: () => void

  constructor() {
    this.initialization = new Promise(resolve => this.resolveInitialization = resolve)
  }

  initialize = (partyId: number, shopId: number) => {
    if (this.partyId !== undefined && this.shopId !== undefined) { return }

    this.partyId = partyId
    this.shopId = shopId

    this.resolveInitialization()
    this.fetchDeliveryPolicies().then(() => {})
  }

  private fetchDeliveryPolicies = async () => {
    await this.initialization

    if (this.partyId === undefined || this.shopId === undefined) {
      throw new Error('DeliveryPolicyMutator not properly initialized')
    }

    const getDeliveryPoliciesRequest = {
      party_id: this.partyId,
      shop_id: this.shopId,
    }

    this.basketApi.getDeliveryPolicies(getDeliveryPoliciesRequest)
      .then((response) => {
        const sortedDeliveryPolicies = sortDeliveryPolicies(response.deliveryPolicies)
        setDeliveryPolicies(sortedDeliveryPolicies)
        setDefault(response.default)
      })
  }
}


export const DELIVERY_POLICY_STORE = Symbol('DELIVERY_POLICY_STORE')
export type DeliveryPolicyStore = {
  deliveryPolicies: () => DeliveryPolicy[]
  defaultDeliveryPolicy: () => DeliveryPolicy
}

@registerDependency(REAL, DELIVERY_POLICY_STORE)
@registerDependency(FAKE, DELIVERY_POLICY_STORE)
export class ConcreteDeliveryPolicyResponseStore implements DeliveryPolicyStore {
  deliveryPolicies = getDeliveryPolicies
  defaultDeliveryPolicy = getDefault
}
